var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPro6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Komponente_10_50",
    "data-name": "Komponente 10 \\u2013 50",
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.169,
    height: 69.498,
    viewBox: "0 0 58.169 69.498",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "recipe-book",
    transform: "translate(-46.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35470",
    "data-name": "Gruppe 35470",
    transform: "translate(46.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35469",
    "data-name": "Gruppe 35469"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46774",
    "data-name": "Pfad 46774",
    d: "M88.308,0H47.414a1.152,1.152,0,0,0-1.152,1.152v56.7A1.152,1.152,0,0,0,47.414,59H88.308A6.3,6.3,0,0,0,94.6,52.708V6.292A6.3,6.3,0,0,0,88.308,0ZM92.3,52.708A3.992,3.992,0,0,1,88.308,56.7H55.649V52.01a1.152,1.152,0,0,0-2.3,0V56.7H48.567V2.3h4.777V42.791a1.152,1.152,0,0,0,2.3,0V2.3H88.308A3.992,3.992,0,0,1,92.3,6.292Z",
    transform: "translate(-46.262)",
    fill: "#2ecf96"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35472",
    "data-name": "Gruppe 35472",
    transform: "translate(60.426 8.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35471",
    "data-name": "Gruppe 35471"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46775",
    "data-name": "Pfad 46775",
    d: "M189.787,74.535a6.494,6.494,0,0,0-1.443.161,6.482,6.482,0,0,0-11.178.015,6.484,6.484,0,0,0-3.345,12.524v7.833a1.152,1.152,0,0,0,1.152,1.152h15.5a1.152,1.152,0,0,0,1.152-1.152V87.233a6.483,6.483,0,0,0-1.843-12.7Zm.543,10.625a1.152,1.152,0,0,0-1,1.143v7.613h-13.2V86.3a1.152,1.152,0,0,0-1.006-1.143,4.178,4.178,0,0,1,.54-8.32,4.14,4.14,0,0,1,1.65.338,1.152,1.152,0,0,0,1.536-.655,4.179,4.179,0,0,1,7.82-.021,1.152,1.152,0,0,0,1.52.655,4.178,4.178,0,1,1,2.144,8Z",
    transform: "translate(-169.177 -71.504)",
    fill: "#2ecf96"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35474",
    "data-name": "Gruppe 35474",
    transform: "translate(64.654 44.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35473",
    "data-name": "Gruppe 35473"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46776",
    "data-name": "Pfad 46776",
    d: "M223.148,388.063H207.015a1.152,1.152,0,1,0,0,2.3h16.133a1.152,1.152,0,0,0,0-2.3Z",
    transform: "translate(-205.863 -388.063)",
    fill: "#2ecf96"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35476",
    "data-name": "Gruppe 35476",
    transform: "translate(64.654 49.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35475",
    "data-name": "Gruppe 35475"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46777",
    "data-name": "Pfad 46777",
    d: "M223.148,428.063H207.015a1.152,1.152,0,1,0,0,2.3h16.133a1.152,1.152,0,0,0,0-2.3Z",
    transform: "translate(-205.863 -428.063)",
    fill: "#2ecf96"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35478",
    "data-name": "Gruppe 35478",
    transform: "translate(78.734 40.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35477",
    "data-name": "Gruppe 35477"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46778",
    "data-name": "Pfad 46778",
    d: "M331.255,348.063H329.2a1.152,1.152,0,1,0,0,2.3h2.053a1.152,1.152,0,0,0,0-2.3Z",
    transform: "translate(-328.05 -348.063)",
    fill: "#2ecf96"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35480",
    "data-name": "Gruppe 35480",
    transform: "translate(64.654 40.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35479",
    "data-name": "Gruppe 35479"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46779",
    "data-name": "Pfad 46779",
    d: "M211.877,348.063h-4.861a1.152,1.152,0,1,0,0,2.3h4.861a1.152,1.152,0,0,0,0-2.3Z",
    transform: "translate(-205.863 -348.063)",
    fill: "#2ecf96"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35482",
    "data-name": "Gruppe 35482",
    transform: "translate(74.121 40.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35481",
    "data-name": "Gruppe 35481"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46780",
    "data-name": "Pfad 46780",
    d: "M290.3,349.273a1.2,1.2,0,0,0-.066-.217,1.167,1.167,0,0,0-.106-.2,1.109,1.109,0,0,0-.144-.175,1.152,1.152,0,0,0-.373-.25,1.216,1.216,0,0,0-.215-.066,1.14,1.14,0,0,0-.451,0,1.16,1.16,0,0,0-.215.066,1.138,1.138,0,0,0-.2.106,1.161,1.161,0,0,0-.175.144,1.1,1.1,0,0,0-.143.175,1.167,1.167,0,0,0-.106.2,1.2,1.2,0,0,0-.066.217,1.107,1.107,0,0,0,0,.449,1.167,1.167,0,0,0,.066.215,1.135,1.135,0,0,0,.106.2,1.118,1.118,0,0,0,.318.318,1.144,1.144,0,0,0,.2.106,1.162,1.162,0,0,0,.215.066,1.113,1.113,0,0,0,.451,0,1.216,1.216,0,0,0,.215-.066,1.167,1.167,0,0,0,.2-.106,1.141,1.141,0,0,0,.319-.318,1.134,1.134,0,0,0,.106-.2,1.167,1.167,0,0,0,.066-.215,1.171,1.171,0,0,0,0-.449Z",
    transform: "translate(-288.02 -348.345)",
    fill: "#2ecf96"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35484",
    "data-name": "Gruppe 35484",
    transform: "translate(53.323 46.245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35483",
    "data-name": "Gruppe 35483"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46781",
    "data-name": "Pfad 46781",
    d: "M109.824,402.242a1.174,1.174,0,0,0-.066-.215,1.14,1.14,0,0,0-.106-.2,1.164,1.164,0,0,0-.143-.175,1.211,1.211,0,0,0-.175-.143,1.232,1.232,0,0,0-.2-.106,1.167,1.167,0,0,0-.215-.066,1.14,1.14,0,0,0-.451,0,1.161,1.161,0,0,0-.215.066,1.225,1.225,0,0,0-.2.106,1.211,1.211,0,0,0-.175.143,1.1,1.1,0,0,0-.143.175,1.146,1.146,0,0,0-.106.2,1.162,1.162,0,0,0-.066.215,1.128,1.128,0,0,0-.023.225,1.161,1.161,0,0,0,.338.815,1.211,1.211,0,0,0,.175.143,1.238,1.238,0,0,0,.2.106,1.071,1.071,0,0,0,.215.066,1.126,1.126,0,0,0,.225.023,1.137,1.137,0,0,0,.226-.023,1.074,1.074,0,0,0,.215-.066,1.161,1.161,0,0,0,.375-.249,1.162,1.162,0,0,0,.338-.815A1.136,1.136,0,0,0,109.824,402.242Z",
    transform: "translate(-107.541 -401.315)",
    fill: "#2ecf96"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35488",
    "data-name": "Gruppe 35488",
    transform: "translate(-335.831 -2891.502)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_555",
    "data-name": "Ellipse 555",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(364 2931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_554",
    "data-name": "Ellipse 554",
    transform: "translate(367 2934)",
    fill: "#fff",
    stroke: "#2ecf96",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-database",
    "data-name": "Icon metro-database",
    d: "M7.571,1.928c-2.761,0-5,.7-5,1.563v1.25c0,.863,2.239,1.562,5,1.562s5-.7,5-1.562V3.491C12.571,2.628,10.332,1.928,7.571,1.928Zm0,5.313c-2.761,0-5-.7-5-1.562V7.553c0,.863,2.239,1.563,5,1.563s5-.7,5-1.563V5.678C12.571,6.541,10.332,7.241,7.571,7.241Zm0,2.812c-2.761,0-5-.7-5-1.562v1.875c0,.863,2.239,1.563,5,1.563s5-.7,5-1.562V8.491C12.571,9.353,10.332,10.053,7.571,10.053Z",
    transform: "translate(371.429 2939.072)",
    fill: "#2ecf96"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro6);
export default __webpack_public_path__ + "static/media/Pro6.35cd6ce067941c45b4b0f1710721ec20.svg";
export { ForwardRef as ReactComponent };